module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm3_m_jp.c835f3833964864467261d0c76878858.png";